import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';

export interface BarcodeQuestionConfig extends WorkflowQuestionConfig {
  allowMultiple?: boolean;
  includeQuantity?: boolean;
}

export interface BarcodeEntry {
  value: string;
  quantity?: number;
}

export interface BarcodeResponseState extends WorkflowResponseState {
  barcodes?: BarcodeEntry[];
}
